import { LegendLabel } from '@modules/charts/types';
import { useGetColor } from '@modules/common/hooks';
import { getSentimentColor } from '@modules/common/utils';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/system';
import { FieldNames } from 'v2/core/entities/fields';

interface GetLineChartStrokeColorProps {
  fieldName: FieldNames | undefined;
  shouldUsePrimaryStrokeColor: boolean;
}

export const useGetLineChartStrokeColor = ({
  fieldName,
  shouldUsePrimaryStrokeColor,
}: GetLineChartStrokeColorProps) => {
  const theme: Theme = useTheme();
  const getChartColor = useGetColor({ fieldName });

  const getStrokeColor = (index: number, label: LegendLabel) => {
    if (shouldUsePrimaryStrokeColor) {
      return theme.palette.primary.main;
    }

    const defaultChartColor = getChartColor(index, label.name);

    if (fieldName !== FieldNames.Entity) {
      return defaultChartColor;
    }

    return getSentimentColor(label.id) ?? defaultChartColor;
  };

  return getStrokeColor;
};
